import { isBefore, isValid, parseISO } from "date-fns"

export const mode = "PROD" // DEV/PROD
export const apiUrl =
  mode === "DEV" ? "https://example.com" : "https://example.com"

export const googleAPIKeys =
  mode === "DEV"
    ? "AIzaSyBZARdFM1Xiy-Pv9emPKFL7_DRTUWz1fQI"
    : "AIzaSyBZARdFM1Xiy-Pv9emPKFL7_DRTUWz1fQI"

export const defaultLat = 23.8859
export const defaultLng = 45.0792

export const hasStarted = startsAt => {
  if (!startsAt) return false // Handle missing value

  const startDate = parseISO(startsAt)
  if (!isValid(startDate)) return false // Handle invalid date

  return isBefore(startDate, new Date()) // Check if it has started
}

export const hasExpired = endsAt => {
  if (!endsAt) return false // Handle missing value

  const endDate = parseISO(endsAt)
  if (!isValid(endDate)) return false // Handle invalid date

  return isBefore(endDate, new Date()) // Check if it has expired
}
